import React, { useCallback, useEffect, useLayoutEffect, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";

// css
import styles from "./addAppoinmentForm.module.scss";

import { Formik } from "formik";
import AppInputField from "components/shared/FormComponents/AppInputField";
import { cloneDeep, debounce } from "lodash";
import { generatePath, useNavigate, useParams } from "react-router-dom";
import { getGuardianOptionLabel, successMessageToast, userFullName } from "helpers/common";
import { APPOINTMENT_FORMS_VIEW, APPOINTMENT_LIST, MANAGE_PARENTS_LIST } from "config/paths";
import LoadingIndicator from "components/shared/LoadingIndicator";
import addParentSchema from "./addAppoinment.schema";
import { useCreateParentMutation, useGetParentsListQuery, useUpdateParentMutation } from "store/services/parents";
import { APPOINTMENT_CLIENT_TYPE_OPTIONS, APPOINTMENT_SERVICE_OPTIONS, APPOINTMENT_SESSION_TYPE_OPTIONS, CLIENT_TYPE_OPTIONS, MIME_TYPES } from "config/constants";
import { CommonMultiSelect, CommonSelect, RequiredFieldAstrick } from "components/Common/Common";
import AppDatePicker from "components/shared/FormComponents/AppDatePicker";
import { useCreateAppointmentMutation, useGetAppointmentAssessmentListQuery, useGetAppointmentConsentListQuery, useGetAppointmentDetailsQuery, useLazyGetAppointmentClientsListQuery, useLazyGetAppointmentConsentListQuery, useLazyGetAppointmentParentsListQuery, useUpdateAppointmentMutation } from "store/services/appointment";
import AppFileUploadField from "components/shared/FormComponents/AppFileUploadField";
import appointmentsValidationSchema from "./addAppoinment.schema";
import ConfirmedAppointmentModal from "components/Modals/ConfirmedAppointment";
import AssignTherapistAndChatterModal from "components/Modals/Appointments/AssignTherapistAndChatter";
import { ViewDocumentIcon } from "Assets/icons";

//TODO: 
// 1. rename all things related to appointment instead of parent creation
// 2. use form data of commented section to list and also similar api will be use to list parent categories and other things as in therapist panel appointment popup

const AddAppointment = () => {

  const { id } = useParams();
  const editMode = !!id;
  const navigate = useNavigate();

  const [initialValues, setInitialValues] = useState({
    firstname: "",
    clientId: "",
    parentId: "",
    title: "",
    description: "",
    additional_notes: "",
    parentLastname: "",
    parentFirstname: "",
    parentEmail: "",
    parentPhone: "",
    clientType: "",
    appointment_reason: "",
    appointment_type: "",
    clientResources: "",
    assessment_services: [],
    consent_forms: [],
    sendConsentToParent: true
  });
  const [clientOptions, setClientOptions] = useState([]);
  const [parentOptions, setParentOptions] = useState([]);
  const [assessmentOptions, setAssessmentOptions] = useState([]);
  const [consentFormOptions, setConsentFormOptions] = useState([]);
  const [confirmedModal, setConfirmedModal] = useState(false)
  const [confirmedData, setConfirmedData] = useState(null)

  const [getParentsList, { isLoading: getParentsLoading }] = useLazyGetAppointmentParentsListQuery();
  const [getClientList, { isFetching: getClientListLoading }] = useLazyGetAppointmentClientsListQuery();
  const { data: assessmentProgramList, isFetching: assessmentProgramListFetching } = useGetAppointmentAssessmentListQuery();
  const [getConsentForms, { isFetching: consentFormListFetching }] = useLazyGetAppointmentConsentListQuery();
  const [createAppointment, { isLoading: createAppointmentLoading }] = useCreateAppointmentMutation()
  const { data: appointmentDetails, isFetching: appoinmentDetailsLoading } = useGetAppointmentDetailsQuery({ id }, { skip: !id })
  const [updateAppointment, { isLoading: updateAppointmentLoading }] = useUpdateAppointmentMutation()

  const getConsentLookup = async (clientType) => {
    try {
      let result = null;
      if (clientType) {
        result = await getConsentForms({ clientType }).unwrap();
      }
      console.log("RESULT OF DAT A ", result)
      if (!result?.length) {
        return;
      }

      const options = result?.map((item) => ({ value: item.id, label: item?.title }));
      setConsentFormOptions(options)

    } catch (err) {
      console.error("error fetching guardians", err)
    };
  }


  const handleSubmit = async (values) => {


    const body = {
      client_id: values?.clientId?.value,
      guardian_id: values?.parentId,
      title: values?.title,
      description: values?.description,
      additional_notes: values?.additional_notes,
      appointment_reason: values?.appointment_reason,
      appointment_type: values?.appointment_type?.value,
      assessment_services: values?.assessment_services?.map((item) => item?.value),
      consent_forms: values?.consent_forms?.map((item) => item?.value),
      clientResources: values?.clientResources,
      appointment_category: values?.clientType?.value,
      sendConsentToParent: values?.sendConsentToParent,
      // price: 0.00,
      // appointment_date: {
      //   "date": "2023-10-01"
      // },
      // "appointment_slot": {
      //   "start": "10:00",
      //   "end": "11:00"
      // },
      // "appointment_status": "pending",
      // "payment_response": null,
      // "payment_status": "pending",
      // "payment_mode": "online",
      // "clientResources": null,
      // "appointment_category": "General",
      // "therapists_assigned": null,
      // "calenderlinks": null
    }
    try {

      // const values = cloneDeep(payload);

      const result = editMode ? await updateAppointment({ body, id }) : await createAppointment({ body }).unwrap();
      if (result?.error) {
        console.error("Error Private Client", result.error);
        return;
      };
      if (!editMode) {
        setConfirmedData(values)
        setConfirmedModal(true)
      }
      successMessageToast(result?.data?.message);
      // navigate(APPOINTMENT_LIST);
    } catch (err) { console.error("Error Creating Appointment ", err); }
  };

  const getGuardianLookup = async (search, type) => {
    try {

      let result = null;
      const body = {
        search,
        limit: 20
      }

      result = await getParentsList({ body }).unwrap();


      if (!result?.records?.length) {
        return;
      }

      const guardianList = result?.records?.map((item) => ({ value: item.id, label: getGuardianOptionLabel(item), ...item }));
      setParentOptions(guardianList)

    } catch (err) {
      console.error("error fetching guardians", err)
    };
  };

  const getClientListLookup = async (clientCategory, parentId) => {
    try {
      let result = null;
      if (clientCategory) {
        const body = {
          client_category: clientCategory
        }
        result = await getClientList({ body, parentId }).unwrap();
      }
      if (!result?.records?.length) {
        return;
      }

      const options = result?.records?.map((item) => ({ value: item.id, label: `${item.firstname} ${item.lastname}` }));
      setClientOptions(options)

    } catch (err) {
      console.error("error fetching guardians", err)
    };
  }

  const handleSearch = useCallback(debounce((search = "", type) => {
    if (search) getGuardianLookup(search, type);
    else {
      setParentOptions([]);
    }
  }, 500), []);

  useEffect(() => {
    if (appointmentDetails) {
      setInitialValues((prev) => ({
        ...prev,

        parentFirstname: appointmentDetails?.record?.appointmentGuardian?.firstname,
        parentLastname: appointmentDetails?.record?.appointmentGuardian?.lastname,
        parentEmail: appointmentDetails?.record?.appointmentGuardian?.email,
        parentPhone: appointmentDetails?.record?.appointmentGuardian?.phone,
        clientId: appointmentDetails?.record?.clientId,
        parentId: appointmentDetails?.record?.parentId,
        title: appointmentDetails?.record?.title,
        description: appointmentDetails?.record?.description,
        additional_notes: appointmentDetails?.record?.additional_notes,
        appointment_reason: appointmentDetails?.record?.appointment_reason,
        clientId: { label: userFullName(appointmentDetails?.record?.appointmentClient), value: appointmentDetails?.record?.appointmentClient?.id },
        appointment_type: { label: appointmentDetails?.record?.appointment_type, value: appointmentDetails?.record?.appointment_type },
        clientType: { label: appointmentDetails?.record?.appointmentClient?.client_detail?.client_type, value: appointmentDetails?.record?.appointmentClient?.client_detail?.client_type },
        // assessment_services: appointmentDetails?.record?.assessment_services,
        clientResources: appointmentDetails?.record?.clientResources,
        consent_forms: appointmentDetails?.assignedConsentForms?.map((item) => ({ label: item?.title, value: item?.id })),
      }))
    }
  }, [appointmentDetails])

  useLayoutEffect(() => {
    if (assessmentProgramList?.length > 0 && appointmentDetails) {
      const data = assessmentProgramList?.filter((item) => appointmentDetails?.record?.assessment_services?.includes(item?.id))
      setInitialValues((prev) => ({ ...prev, assessment_services: data?.map((item) => ({ label: item?.program_name, value: item?.id })) }))
    }
  }, [assessmentProgramList, appointmentDetails]);

  useLayoutEffect(() => {
    if (assessmentProgramList?.length > 0) {
      const data = assessmentProgramList?.map((item) => ({ label: item?.program_name, value: item?.id }))
      setAssessmentOptions(data)
    }
  }, [assessmentProgramList]);

  return (
    <>
        <ConfirmedAppointmentModal
          show={confirmedModal}
          setShow={setConfirmedModal}
          data={confirmedData}
        />
      <section className={`${styles.addForm} position-relative py-4 addForm`}>
        <h3 className="px-3">{`${editMode ? "EDIT" : "ADD"} APPOINTMENT`}</h3>
        <Container fluid={true}>
          <Row>
            {
              appoinmentDetailsLoading ? <LoadingIndicator /> :
                <Col lg="12" className="my-2">
                  <Formik
                    initialValues={initialValues}
                    validationSchema={appointmentsValidationSchema}
                    onSubmit={handleSubmit}
                    enableReinitialize
                  >
                    {({
                      handleSubmit, values, setFieldValue, errors
                    }) => (
                      <Form onSubmit={handleSubmit}>
                        <div
                          className="py-3"
                        //   style={{ borderTop: "1px solid #41a2a84d" }}
                        >
                          <Row>
                            <Col md="6" sm="4" className="mt-2">
                              <label className="form-label fw-bold themeBlue d-flex my-2">
                                Title
                                <RequiredFieldAstrick />
                              </label>
                              <AppInputField
                                name={`title`}
                                placeholder="Enter Title"
                                className={`${styles.formControl} form-control`}
                              />
                            </Col>
                            {/* <Col md="6" sm="12" className="mt-2">
                              <label className="form-label fw-bold themeBlue d-flex my-2">
                                Appointment Reason
                                <RequiredFieldAstrick />
                              </label>
                              <AppInputField
                                name={`appointment_reason`}
                                placeholder="Enter Appointment Reason"
                                className={`${styles.formControl} form-control`}
                              />
                            </Col> */}
                            {/* <Col md="12" sm="12" className="mt-2">
                              <label className="form-label fw-bold themeBlue d-flex my-2">
                                Description
                              </label>
                              <AppInputField
                                name={`description`}
                                placeholder="Enter Description"
                                fieldType={"textarea"}
                                className={`${styles.formControl} form-control`}
                                maxLength={500}
                                style={{ height: "100px" }}
                              />
                            </Col> */}
                            <Col md="12" sm="12" className="my-2">
                              <hr />
                              <label
                                htmlFor=""
                                className="form-label themeBlue fw-bold mb-0 d-flex my-2"
                                style={{ fontSize: "15px" }}
                              >
                                Parent / Guardian Details
                              </label>
                              <ul className="list-unstyled ps-0 mb-0">
                                <Row className="align-items-center">
                                  <Col lg="12">
                                    <Row>
                                      <Col md="3" sm="6" className="my-2">
                                        <label
                                          htmlFor=""
                                          className="form-label themeBlue fw-bold mb-0 d-flex"
                                        >
                                          Last Name
                                          <RequiredFieldAstrick />
                                        </label>
                                        {/* <GuardianPicker
                                          type="parents"
                                          name={`parentLastname`}
                                          placeholder={"Search Last Name"}
                                        /> */}
                                        <CommonSelect
                                          isDisabled={editMode}
                                          placeholder={"Select Parent"}
                                          // isDisabled={editMode}
                                          isClearable
                                          name="parentLastname"
                                          handleBlur={() => setParentOptions([])}
                                          // creatable={true}
                                          onInputChange={(e) => handleSearch(e, "parents}")}
                                          option={parentOptions}
                                          isLoading={getParentsLoading}
                                          value={values?.parentLastname && { label: values?.parentLastname, value: values?.parentLastname }}
                                          onChange={(selected) => {
                                            let guardian = parentOptions?.find(guardian => guardian.id === selected?.value);
                                            let selectedValue = {
                                              ...selected,
                                              label: guardian?.lastname
                                            };
                                            if (!guardian) {
                                              setClientOptions([])
                                              setFieldValue(`parentLastname`, selected);
                                              setFieldValue(`parentId`, null);
                                              setFieldValue(`parentFirstname`, "");
                                              setFieldValue(`parentEmail`, "");
                                              setFieldValue(`parentPhone`, "");
                                              setFieldValue('clientType', "")
                                              setFieldValue('clientId', "")
                                              setConsentFormOptions([]);
                                              setFieldValue("consentForms", []);

                                              return;
                                            }
                                            setFieldValue(`parentLastname`, guardian.lastname);
                                            setFieldValue(`parentId`, selectedValue.id);
                                            setFieldValue(`parentFirstname`, guardian?.firstname);
                                            setFieldValue(`parentEmail`, guardian?.email);
                                            setFieldValue(`parentPhone`, guardian?.phone);
                                            setFieldValue('clientType', "")
                                            setFieldValue('clientId', "")
                                            setParentOptions([])
                                            setConsentFormOptions([]);
                                            setFieldValue("consentForms", []);
                                          }}
                                        />
                                      </Col>
                                      <Col md="3" sm="6" className="my-2">
                                        <label
                                          htmlFor=""
                                          className="form-label themeBlue fw-bold mb-0 d-flex"
                                        >
                                          First Name
                                          <RequiredFieldAstrick />
                                        </label>
                                        <AppInputField
                                          disabled
                                          name={`parentFirstname`}
                                          placeholder="e.g John Smith"
                                          className={`${styles.formControl} form-control`}
                                        />
                                      </Col>
                                      <Col md="3" sm="6" className="my-2">
                                        <label
                                          htmlFor=""
                                          className="form-label themeBlue fw-bold mb-0 d-flex"
                                        >
                                          Email
                                          <RequiredFieldAstrick />
                                        </label>
                                        <AppInputField
                                          disabled
                                          name={`parentEmail`}
                                          placeholder="John@gmail.com"
                                          className={`${styles.formControl} form-control`}
                                        />
                                      </Col>
                                      <Col md="3" sm="6" className="my-2">
                                        <label
                                          htmlFor=""
                                          className="form-label themeBlue fw-bold mb-0 d-flex"
                                        >
                                          Phone
                                          <RequiredFieldAstrick />
                                        </label>
                                        <AppInputField
                                          disabled
                                          name={`parentPhone`}
                                          placeholder="+1234567890"
                                          className={`${styles.formControl} form-control`}
                                          maxLength={25}
                                        />
                                      </Col>
                                    </Row>
                                  </Col>
                                  <Col lg="2">
                                    <Button
                                      className="border-0 p-0"
                                      variant="transparnet"
                                    >

                                    </Button>
                                  </Col>
                                </Row>
                              </ul>

                              <hr />
                            </Col>
                            {
                              <Col md="6" sm="4" className="mt-2">
                                <label className="form-label fw-bold themeBlue d-flex my-2">
                                  Client Type
                                  <RequiredFieldAstrick />
                                </label>
                                <CommonSelect

                                  name={"clientType"}
                                  option={APPOINTMENT_CLIENT_TYPE_OPTIONS}
                                  placeholder={"Select Client Type"}
                                  onChange={(val) => {
                                    setConsentFormOptions([]);
                                    setFieldValue("consentForms", []);
                                    setClientOptions([]);
                                    getClientListLookup(val.value, values?.parentId);
                                    getConsentLookup(val.value)
                                    // setValues({
                                    //   ...values,
                                    //   client_type: val,
                                    //   client_id: ""
                                    // })
                                  }}
                                  isDisabled={editMode || !values?.parentId}
                                />
                              </Col>
                            }
                            {
                              <Col md="6" sm="4" className="mt-2">
                                <label className="form-label fw-bold themeBlue d-flex my-2">
                                  Client
                                  <RequiredFieldAstrick />
                                </label>
                                <CommonSelect
                                  name={"clientId"}
                                  option={clientOptions}
                                  placeholder={"Select Client"}
                                  isLoading={getClientListLoading}
                                  isDisabled={editMode}
                                />
                              </Col>
                            }

                            <Col md="6" sm="4" className="mt-2">
                              <label className="form-label fw-bold themeBlue d-flex my-2">
                                Appointment Type
                                <RequiredFieldAstrick />
                              </label>
                              <CommonSelect
                                name={"appointment_type"}
                                option={APPOINTMENT_SESSION_TYPE_OPTIONS}
                                placeholder={"Select Client Type"}
                                isDisabled={editMode}
                              />
                            </Col>
                            {
                              ["Funded", "funded"]?.includes(values?.appointment_type?.value) &&
                              <Col md="6" sm="12" className="mt-2">
                                <label className="form-label fw-bold themeBlue d-flex my-2">
                                  Upload Documents
                                </label>
                                <AppFileUploadField
                                  name="clientResources"
                                  acl={"private"}
                                  accept="image/*, application/pdf, .doc, .docx"
                                  allowedTypes={[MIME_TYPES.pdf, MIME_TYPES.png, MIME_TYPES.jpeg, MIME_TYPES.jpg, MIME_TYPES.webp, MIME_TYPES.doc, MIME_TYPES.docx]}
                                  className={`${styles.formControl} form-control`}
                                // onChange={(name, value) => {
                                //   handleAttachDocument(name, value, values?.contracts, setFieldValue);
                                // }}
                                />
                                {(errors?.clientResources) ? (
                                  <div className="error">{typeof errors?.clientResources === "string" ? errors?.clientResources : errors?.clientResources}</div>
                                ) : null}
                              </Col>
                            }

                            {console.log('errors of vaidations', errors)}

                            <Col md="6" sm="4" className="mt-2">
                              <label className="form-label fw-bold themeBlue d-flex my-2">
                                Service
                                <RequiredFieldAstrick />
                              </label>
                              <CommonMultiSelect
                                name={"assessment_services"}
                                option={assessmentOptions}
                                isLoading={assessmentProgramListFetching}
                                placeholder={"Select Client Type"}
                              // onChange={(val) => {
                              //   setClientOptions([]);
                              //   getClientOptions(val);
                              //   setValues({
                              //     ...values,
                              //     client_type: val,
                              //     client_id: ""
                              //   })
                              // }}
                              // isDisabled={editMode}
                              />
                            </Col>
                            <Col md="6" sm="4" className="mt-2">
                              <label className="form-label fw-bold themeBlue d-flex my-2">
                                Consent Forms
                                <RequiredFieldAstrick />
                              </label>
                              <CommonMultiSelect
                                name={"consent_forms"}
                                option={consentFormOptions}
                                placeholder={"Select Consent Forms"}
                                isLoading={consentFormListFetching}
                                // onChange={(val) => setFieldValue('consentForm', val)}
                                // onChange={(val) => {
                                //   setClientOptions([]);
                                //   getClientOptions(val);
                                //   setValues({
                                //     ...values,
                                //     client_type: val,
                                //     client_id: ""
                                //   })
                                // }}
                                isDisabled={editMode}
                              />
                              {
                                values?.consent_forms?.length > 0 &&
                                <div className="w-100">
                                  <table className="w-100">
                                    <thead>
                                      <tr>
                                        <th style={{ padding: "10px 15px" }}>Name</th>
                                        <th style={{ padding: "10px 15px", textAlign: "center" }}>View</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {
                                        values?.consent_forms?.map((item) => <tr className="  ">
                                          <td>{item?.label}</td>
                                          <td className="text-end"> <div
                                            className={`${styles.btnWrpper} btnWrpper d-flex justify-content-end align-items-center gap-10 pt-3`}
                                          >
                                            <Button type="button" onClick={() => window.open(generatePath(APPOINTMENT_FORMS_VIEW, { id: item?.value, mode: "preview" }), '_blank')} className="d-flex align-items-center justify-content-center commonBtn">
                                              Preview
                                            </Button>

                                            {/* <Button
                              type="button"
                              className="d-flex align-items-center justify-content-center commonBtn borderedBtn bg-transparent"
                              onClick={() => navigate(MANAGE_PARENTS_LIST)}
                            >
                              Cancel
                            </Button> */}
                                          </div></td>
                                        </tr>)
                                      }
                                    </tbody>
                                  </table>
                                  {/* <th className="d-flex justify-content-between">
                                    <td>Name</td>
                                    <td>View</td>
                                  </th>
                                  <tbody>
                                    {
                                      values?.consent_forms?.map((item) => <tr className="d-flex justify-content-between">
                                        <td>{item?.label}</td>
                                        <td><ViewDocumentIcon /></td>
                                      </tr>)
                                    }
                                  </tbody> */}
                                </div>
                              }
                            </Col>
                            <Col md="12" sm="12" className="mt-2">
                              <label className="form-label fw-bold themeBlue d-flex my-2">
                                Additonal Notes
                              </label>
                              <AppInputField
                                name={`additional_notes`}
                                placeholder="Enter Additonal Notes"
                                fieldType={"textarea"}
                                className={`${styles.formControl} form-control`}
                                maxLength={500}
                                style={{ height: "100px" }}
                              />
                            </Col>

                            {
                              !editMode &&
                              <Col md="12" sm="12" className="mt-5">
                                {/* <label className="form-label fw-bold themeBlue d-flex my-2">
                              Additonal Notes
                            </label> */}

                                <div className="d-flex align-items-center gap-2">
                                  <input
                                    type="checkbox"
                                    style={{ height: 20, width: 20, accentColor: "green" }}
                                    className="form-check"
                                    checked={values?.sendConsentToParent}
                                    onChange={e => setFieldValue("sendConsentToParent", !values?.sendConsentToParent)}
                                  />
                                  <p
                                    style={{ fontSize: "15px" }}
                                    className="m-0 themeBlue cursor-pointer user-select-none"
                                    onClick={e => setFieldValue("sendConsentToParent", !values?.sendConsentToParent)}
                                  >
                                    Send consent forms to parent via email.
                                  </p>
                                </div>

                              </Col>
                            }
                          </Row>
                        </div>
                        <Row className="mt-4">
                          <Col className="my-2" lg="12">
                            {/* <p><strong>Please note:</strong> Once the appointment is created, an email notification will be automatically sent to all selected parents.</p> */}
                          </Col>
                        </Row>
                        <Row className="mt-4">
                          <Col className="my-2" lg="12">
                            <div
                              className={`${styles.btnWrpper} btnWrpper d-flex align-items-center gap-10 pt-3`}
                              style={{ borderTop: "1px solid #41a2a84d" }}
                            >
                              <Button type="submit" disabled={createAppointmentLoading || updateAppointmentLoading} className="d-flex align-items-center justify-content-center commonBtn">
                                {createAppointmentLoading || updateAppointmentLoading ? <LoadingIndicator inline /> : "Save"}

                              </Button>
                              {/* <Button
                              type="button"
                              className="d-flex align-items-center justify-content-center commonBtn borderedBtn bg-transparent"
                              onClick={() => navigate(MANAGE_PARENTS_LIST)}
                            >
                              Cancel
                            </Button> */}
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    )}
                  </Formik>


                </Col>
            }
          </Row>
        </Container>
      </section>
    </>
  );
};

export default AddAppointment;
